import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled(Stack)``;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  &:hover {
    text-decoration: underline;
    color: ${(p) => p.theme.palette.primary[500]};
    p {
      color: ${(p) => p.theme.palette.primary[500]};
    }
  }
`;
